import { render, staticRenderFns } from "./RegisterCompanyV2.vue?vue&type=template&id=55356196"
import script from "./RegisterCompanyV2.vue?vue&type=script&lang=ts"
export * from "./RegisterCompanyV2.vue?vue&type=script&lang=ts"
import style0 from "./RegisterCompanyV2.vue?vue&type=style&index=0&id=55356196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports